import React from "react";
import { Helmet } from "react-helmet";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { useTranslation } from "react-i18next";

const Deklaracja_Page = () => {
    const { t, i18n } = useTranslation();
    const { trackPageView } = useMatomo();
    React.useEffect(() => {
        trackPageView();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Helmet>
                <title>{t("declaration.metaTitle")}</title>
            </Helmet>
            <h2 style={{ fontSize: 34 }}>{t("declaration.title")}</h2>
            <section id="a11y-wstep">
                <p>
                    <span id="a11y-podmiot">{t("Centrum Informatyki Statystycznej")} </span>
                    {t("zobowiązuje się zapewnić dostępność swojej")}{" "}
                    <span id="a11y-zakres">{t("strony internetowej")} </span>
                    {t("declaration.intro")}
                </p>
                <p>
                    {t("declaration.applies")}{" "}
                    <a href={`https://rsi.stat.gov.pl${i18n.language === "en" ? "/en" : ""}`} id="a11y-url">
                        {t("Repozytorium Systemów Informacyjnych")}
                    </a>
                    {i18n.language === "pl" && "."}
                    {t("strona internetowa")}
                </p>
            </section>
            <ul>
                <li>
                    {t("declaration.dates.published")}{" "}
                    <time id="a11y-data-publikacja" datetime="2022-02-17">
                        {t("declaration.dates.publishedDate")}
                    </time>
                </li>
                <li>
                    {t("declaration.dates.updated")}{" "}
                    <time id="a11y-data-aktualizacja" datetime="2023-03-01">
                        {t("declaration.dates.updatedDate")}
                    </time>
                </li>
            </ul>
            <h3>{t("declaration.statusTitle")}</h3>
            <p id="a11y-status">{t("declaration.status")}</p>
            <h3>{t("declaration.nonAccessibleTitle")}</h3>
            <h4>{t("declaration.nonComplianceTitle")}</h4>
            <ul>
                {t("declaration.nonComplianceList", { returnObjects: true }).map((item, idx) => (
                    <li key={idx}>{item}</li>
                ))}
            </ul>
            <h3>{t("declaration.preparationTitle")}</h3>
            <ul>
                <li>
                    {t("declaration.preparationDates.prepared")}{" "}
                    <time id="a11y-data-sporzadzenie" datetime="2022-02-17">
                        {t("declaration.preparationDates.preparedData")}
                    </time>
                </li>
                <li>
                    {t("declaration.preparationDates.reviewed")}{" "}
                    <time id="a11y-data-przeglad" datetime="2025-03-18">
                        {t("declaration.preparationDates.reviewedData")}
                    </time>
                </li>
            </ul>
            <p>
                {t("declaration.preparationDesc")}{" "}
                <a href={`/files/WCAG_${t("Audyt_Raport")}-RSI.pdf`} download>
                    {t("declaration.report")}
                </a>
                .
            </p>
            <h3>{t("declaration.facilitiesTitle")}</h3>
            <h4>{t("declaration.plansTitle")}</h4>
            <p>{t("declaration.plansDesc")}</p>
            <h3>{t("declaration.feedbackTitle")}</h3>
            <p>
                {t("declaration.feedbackDesc")} <span id="a11y-kontakt">{t("declaration.feedbackDescContact")}</span> -{" "}
                {t("mejlowo")}{" "}
                <a id="a11y-email" href="mailto:dostepnosc@stat.gov.pl">
                    dostepnosc@stat.gov.pl
                </a>{" "}
                {t("lub")} {t("telefonicznie")}{" "}
                <a id="a11y-telefon" href="tel:+48226083641">
                    +48 22 608 36 41
                </a>
                .
            </p>
            <p>{t("declaration.rightRequest")}</p>
            <p>{t("declaration.requestDesc")}</p>
            <ul>
                {t("declaration.requestList", { returnObjects: true }).map((item, idx) => (
                    <li key={idx}>{item}</li>
                ))}
            </ul>
            <p>{t("declaration.responseDesc")}</p>
            <p>{t("declaration.responseDeadline")}</p>
            <p>{t("declaration.alternativeDesc")}</p>
            <section id="a11y-procedura">
                <h3>{t("declaration.handlingTitle")}</h3>
                <p>{t("declaration.handlingDesc")}</p>
                <p>{t("declaration.handlingDesc2")}</p>
                <p>{t("declaration.complaintDesc")}</p>
                <ul>
                    <li>
                        <b>{t("declaration.office")}</b>,
                    </li>
                    <li>{t("declaration.address")},</li>
                    <li>
                        {t("declaration.email")}: <a href="mailto:dostepnosc@stat.gov.pl">dostepnosc@stat.gov.pl</a>.
                        <br />
                    </li>
                </ul>
                <p>
                    <a href="https://www.gov.pl/web/gov/zloz-wniosek-o-zapewnienie-dostepnosci-cyfrowej-strony-internetowej-lub-aplikacji-mobilnej">
                        {t("declaration.helpfulInfo")}
                    </a>
                    .
                </p>
                <p>
                    {t("declaration.ombudsman1")}{" "}
                    <a href="https://bip.brpo.gov.pl/pl">{t("Rzecznika Praw Obywatelskich")}</a>{" "}
                    {t("declaration.ombudsman2")}
                </p>
            </section>

            <h3>{t("declaration.otherTitle")}</h3>
            <section id="a11y-architektura">
                <h4>{t("declaration.architecturalTitle")}</h4>
                <h5>{t("declaration.warsawTitle")}</h5>
                <p>{t("declaration.warsawDesc")}</p>
                {t("declaration.warsawDetails", { returnObjects: true }).map((item, idx) => (
                    <p key={idx}>{item}</p>
                ))}
                <h5>{t("declaration.radomTitle")}</h5>
                {t("declaration.radomDetails", { returnObjects: true }).map((item, idx) => (
                    <p key={idx}>{item}</p>
                ))}
                <h5>{t("declaration.lodzTitle")}</h5>
                {t("declaration.lodzDetails", { returnObjects: true }).map((item, idx) => (
                    <p key={idx}>{item}</p>
                ))}
            </section>
            <section id="a11y-komunikacja">
                <h4>{t("declaration.communicationTitle")}</h4>
                <h5>{t("declaration.communication.warsawTitle")}</h5>
                <p>{t("declaration.communication.providesTitle")}</p>
                <ul>
                    {t("declaration.communication.provides", { returnObjects: true }).map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
                <p>{t("declaration.communication.notProvidesTitle")}</p>
                <ul>
                    {t("declaration.communication.notProvides", { returnObjects: true }).map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
                <h5>{t("declaration.communication.radomTitle")}</h5>
                <p>{t("declaration.communication.providesTitle")}</p>
                <ul>
                    {t("declaration.communication.provides", { returnObjects: true }).map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
                <p>{t("declaration.communication.notProvidesTitle")}</p>
                <ul>
                    {t("declaration.communication.notProvides", { returnObjects: true }).map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
                <h5>{t("declaration.communication.lodzTitle")}</h5>
                <p>{t("declaration.communication.providesTitle")}</p>
                <ul>
                    {t("declaration.communication.provides", { returnObjects: true }).map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
                <p>{t("declaration.communication.notProvidesTitle")}</p>
                <ul>
                    {t("declaration.communication.notProvides", { returnObjects: true }).map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
            </section>
        </>
    );
};

export default Deklaracja_Page;
